import {PublicKey} from '@solana/web3.js'

export const CDN_URL = 'https://cdn.piratesquadnft.com/clients/oogy-blast'

export const MEMO_PROGRAM_ID = new PublicKey(
  'MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr'
)